/**
 * changelog.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

// import { AbstractControl } from "@angular/forms";
// import { DataType } from "../common/data/data-types";
// import { TypedDataHolder } from "../common/data/typed-data";

export type SemVer = [number, number, number];
export function semverString (v : SemVer) : string
{
	validateSemver(v);
	return `${v[0]}.${v[1]}.${v[2]}`;
}
export function validateSemver (v : SemVer) : void
{
	if (!Array.isArray(v))
	{
		throw new Error("SemVer is not an array");
	}
	if (v.length !== 3)
	{
		throw new Error("SemVer does not have 3 values");
	}
	if (v.some((val : number) => !Number.isInteger(val) || val < 0))
	{
		throw new Error("SemVer contains nonpositive/noninteger values");
	}
}

export interface Changelog
{
	modified : number;
	changes : ChangeItem[];
	versions : VersionAnnotation[];
}

export interface ChangeItem
{
	version : SemVer;
	// audience : string;
	// tags : string[];
	category : string;
	isFix? : boolean;
	description : string;
	author? : string;
}

export interface VersionAnnotation
{
	version : SemVer;
	date : number;
	displayName? : string;
	description? : string;
	purpose? : string;
}

// type CompactChangeItem = [SemVer, string, string, string[]];
// export function hydrateChangeItem (cci : CompactChangeItem) : ChangeItem
// {
// 	return {
// 		version: cci[0],
// 		description: cci[1],
// 		audience: cci[2],
// 		tags: cci[3]
// 	};
// }


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/configuration/changelog.ts